export const emailRegistrationUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/api/v1/users/email'
    : 'https://club-discovery-backend.herokuapp.com/api/v1/users/email';
// export const emailRegistrationUrl =
//   'https://hackathon-cloud-run-a7l76unudq-ew.a.run.app/email';

// export const redirectUri = 'https://club-finder.netlify.app';
// export const backendUrl = 'https://club-discovery-backend.herokuapp.com';
export const backendUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000'
    : 'https://club-discovery-backend.herokuapp.com';
export const redirectUri =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://club-finder.app';
export const spotifyAuthUrl = 'https://accounts.spotify.com/authorize';
export const spotifyClientId =
  process.env.NODE_ENV === 'development'
    ? '46b9171059a344aaab4ced9d06fb834b'
    : 'e35779d8e771453cb4d0695a2141d075';
export const spotifyClientSecret =
  process.env.NODE_ENV === 'development'
    ? '9486a3f14800411c890ee954fe57f82e'
    : 'db65466d1dbd4c7d8e93772ccd998957';
export const scope = 'user-read-private user-read-email user-top-read';

export const sentryDSN =
  'https://2311fd27c1394190803eda4c6d8b7e22@o337236.ingest.sentry.io/1870125';
